import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PriceList from '#components/products-pricing/PriceList';

const PriceListPage = () => {
  return (
    <Container className='py-4'>
      <Row>
        <Col>
          <PriceList />
        </Col>
      </Row>
    </Container>
  );
};

export default PriceListPage;

